import { ActionType } from 'typesafe-actions';

import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import * as actions from '../actions/coreActions';
import { CoreActionsEnum } from '../enums/CoreActionsEnum';
import { LAW_INTERFACE } from '../constants/localStorageNames';
import { ICoreState } from '../interfaces/ICoreState';
import { getLawInterfaceFromStorage } from '../common/getLawInterfaceFromStorage';

export type CoreAction = ActionType<typeof actions>;

const initialState: ICoreState = {
  loading: 0,
  isDeepLoading: 0,
  announceHeight: undefined,
  lawInterface: getLawInterfaceFromStorage(),
  publicPortalURL: '',
  visibleCheckPluginModal: false,
  notificationInfo: undefined,
};

export function coreReducer(state = initialState, action: CoreAction) {
  switch (action.type) {
    case CoreActionsEnum.CORE_SET_LOADING: {
      let { loading } = state;

      if (action.payload.value) {
        loading += 1;
      } else if (loading !== 0) {
        loading -= 1;
      }
      const newState: ICoreState = {
        ...state,
        loading,
      };

      return newState;
    }
    case CoreActionsEnum.CORE_DEEP_SET_LOADING: {
      let { isDeepLoading } = state;

      if (action.payload.value) {
        isDeepLoading += 1;
      } else if (isDeepLoading !== 0) {
        isDeepLoading -= 1;
      }
      const newState: ICoreState = {
        ...state,
        isDeepLoading,
      };

      return newState;
    }
    case CoreActionsEnum.CORE_SET_LOADING_PROGRESS: {
      const newState: ICoreState = {
        ...state,
        loadingProgress: action.payload.value,
      };

      return newState;
    }
    case CoreActionsEnum.CORE_SET_ANNOUNCE_HEIGHT: {
      const newState: ICoreState = {
        ...state,
        announceHeight: action.payload.value,
      };

      return newState;
    }
    case CoreActionsEnum.CORE_SET_LAW_INTERFACE: {
      localStorage.setItem(LAW_INTERFACE, action.payload.value);
      const newState: ICoreState = {
        ...state,
        lawInterface: action.payload.value,
      };

      return newState;
    }
    case CoreActionsEnum.CORE_SET_PUBLIC_PORTAL_URL: {
      const { url } = action.payload;
      const newState: ICoreState = {
        ...state,
        publicPortalURL: `${url.slice(0, url.length - 1)}${url[url.length - 1] === '/' ? '' : url[url.length - 1]}`,
      };

      return newState;
    }
    case CoreActionsEnum.CORE_SET_VISIBLE_CHECK_PLUGIN_MODAL: {
      const newState: ICoreState = {
        ...state,
        visibleCheckPluginModal: action.payload.visible,
      };

      return newState;
    }
    case CoreActionsEnum.CORE_SET_NOTIFICATION_INFO: {
      const newNotificationItem = action.payload.notificationInfo;
      const currentNotificationInfo = state.notificationInfo || [];

      const newState: ICoreState = {
        ...state,
        notificationInfo: newNotificationItem
          ? [...currentNotificationInfo, newNotificationItem]
          : currentNotificationInfo,
      };

      return newState;
    }
    case CoreActionsEnum.CORE_REMOVE_FIRST_NOTIFICATION_INFO: {
      const newState: ICoreState = {
        ...state,
        notificationInfo: state.notificationInfo?.length ? state.notificationInfo.slice(1) : state.notificationInfo,
      };

      return newState;
    }
    case CoreActionsEnum.CORE_SET_OPEN_API_INFO: {
      const newState: ICoreState = {
        ...state,
        openApiInfo: action.payload.openApiInfo,
      };

      return newState;
    }
    case CoreActionsEnum.CORE_SET_OPTION_NAME: {
      const newState: ICoreState = {
        ...state,
        optionName: action.payload.optionName,
      };

      return newState;
    }
    default:
      return state;
  }
}

export const getAnnounceHeight = (state: IRootState) => state.core.announceHeight;
export const getLawInterface = (state: IRootState) => state.core.lawInterface;
export const getPublicPortalURL = (state: IRootState) => state.core.publicPortalURL;
